export const CategoryBackgroundColor = {
  여행: "#c4d9fa",
  스포츠: "#a3ecf0",
  쇼핑: "#e2cbff",
  음악: "#fbc07a",
  게임: "#f9daa0",
  독서: "#bdebb1",
  요리: "#ffc9d0",
  영화시청: "#bcc3ff",
  반려동물: "#e4b1be",
};
